import { BooleanObject } from '@/types/public'
import { imageTypeListMap, videoTypeListMap } from '@/defination/common'

// 匹配除url地址里得具体文件参数
export function getFileFromUrl(url: string) {
  if (!url) {
    return ''
  }
  // 使用正则表达式匹配路径中的文件名
  const match = url?.match(/([^/]+)\?/) // 匹配路径中最后一个 / 后面的部分，并且后面跟着 ?
  if (match) {
    return match[1] // 返回文件名部分
  } else {
    return url.substring(url.lastIndexOf('/') + 1) // 如果没有查询参数，直接提取最后一个 /
  }
}
// 获取链接文件名和文件后缀
export function getUrlFileBaseInfo(url: string) {
  const matchInfo = getFileFromUrl(url)
  const arr = matchInfo.split('.')
  const suffixValue = arr.pop()
  return {
    fileName: arr[0],
    suffix: suffixValue ? suffixValue.toLocaleLowerCase() : '',
    sourceName: matchInfo,
  }
}
// 判断是否为图片后缀
export function judgeFileUrlIsImage(url: string) {
  const { suffix } = getUrlFileBaseInfo(url)
  if (!suffix) {
    return false
  }
  return !!imageTypeListMap[suffix.toLocaleLowerCase()]
}
// 判断是否为视频后缀
export function judgeFileUrlIsVidoe(url: string) {
  const { suffix } = getUrlFileBaseInfo(url)
  if (!suffix) {
    return false
  }
  return !!videoTypeListMap[suffix.toLocaleLowerCase()]
}
// 获取文件图标
export function getFileUrlSuffixNameIconClass(url: string) {
  let { suffix } = getUrlFileBaseInfo(url)
  const suffixsNameMap = require.context('@/assets/filetype/suffix', false, /\.svg$/)
  const suffixsMap = suffixsNameMap.keys().reduce((result, pathName) => {
    const key = pathName.split('/').pop()?.replace('.svg', '') || ''
    if (key) {
      result[key] = true
    }
    return result
  }, {} as BooleanObject)
  if (imageTypeListMap[suffix]) {
    suffix = 'image'
  }
  if (suffix === 'xlsx') {
    suffix = 'xls'
  }
  if (!suffixsMap[suffix]) {
    if (videoTypeListMap[suffix]) {
      suffix = 'video'
    } else {
      suffix = 'unknow'
    }
  }
  return `file-suffix-image-${suffix}`
}

/**
 * 判断当前环境是否为微信浏览器
 */
export function isWeixin(): boolean {
  const ua = navigator.userAgent.toLowerCase()
  return ua.indexOf('micromessenger') > -1
}

/**
 * 判断当前环境是否为微信小程序
 * 通过 window.__wxjs_environment 检测
 */
export function isWeixinMiniProgram(): boolean {
  if (typeof window !== 'undefined' && window.__wxjs_environment === 'miniprogram') {
    return true
  }
  // 备用检测：用户代理包含 miniProgram 或 miniprogram
  const ua = navigator.userAgent.toLowerCase()
  return ua.indexOf('miniprogram') > -1
}
